// extracted by mini-css-extract-plugin
var _1 = "ZewrQ";
var _2 = "Ft5pM";
var _3 = "n3JNk";
var _4 = "K2qxP";
var _5 = "mMxen";
var _6 = "lsY_D";
export { _1 as "base", _2 as "candidate", _3 as "candidates", _4 as "empty", _5 as "section", _6 as "sectionHeading" }
